import React from 'react';
import { Navigate } from 'react-router-dom';
import { useUserData } from '../auth/UserData';
import { useTheme as useTenantTheme } from '../context/ThemeContext';
import { FullscreenSpinner, paletteFrom } from '../pages/terminal/TerminalAuthShell';

// TerminalProtectedRoute wraps the /terminal entry (and any future
// authenticated terminal-only route such as /terminal/settings) with an
// auth gate that redirects unauthenticated users to /terminal/login —
// not the generic /login used elsewhere in the app. This keeps the
// terminal experience self-contained: users who land on /terminal
// without a session stay inside the terminal branded flow instead of
// bouncing into the main-site login.
//
// Loading state uses TerminalAuthShell's FullscreenSpinner so the
// transition from "auth loading" to "terminal rendered" is visually
// continuous with the shell's own branded loading state.
const TerminalProtectedRoute = ({ children }) => {
  const { user, isLoading } = useUserData();
  const { tenantConfig } = useTenantTheme();

  if (isLoading) {
    return <FullscreenSpinner palette={paletteFrom(tenantConfig)} />;
  }
  if (!user) {
    return <Navigate to="/terminal/login" replace />;
  }
  return children;
};

export default TerminalProtectedRoute;
